import React from 'react'
import { LineChart, Line, XAxis, YAxis, ResponsiveContainer, ReferenceLine } from 'recharts';
import moment from 'moment';

import { Reading, ControllerEvent } from '../../../src/types';

type SensorGraphProps = {
    readings: Reading[],
    dataKey: string,
    height: number,
    minimumTolerance?:number,
    setPoint?:number,
    events?: ControllerEvent[]
};

const SensorGraph = ({ readings, events, dataKey, height, minimumTolerance, setPoint }: SensorGraphProps) => {
    let processedReadings = readings;
    if (readings && readings.length) {
       processedReadings = readings.map(reading => ({
            ...reading,
            createdAt: new Date(reading.createdAt).getTime()
        }));
    }
    let processedEvents = events;
    if (events && events.length) {
        processedEvents = events.map(event => ({
            ...event,
            createdAt: new Date(event.createdAt).getTime()
        }));
    }
    return (
        <ResponsiveContainer width="95%" height={height}>
            <LineChart
                data={processedReadings}>
                <XAxis 
                    dataKey="createdAt"
                    tickFormatter={timeValue => moment(timeValue).format('Do HH:mm')}
                    type="number"
                    domain={['dataMin','dataMax']}
                />
                <YAxis 
                    dataKey={dataKey} 
                    domain={[
                        (dataMin:number) => Math.floor(dataMin) - 1,
                        (dataMax:number) => Math.ceil(dataMax) + 1
                    ]}
                    type="number"
                />
                {processedEvents?.map((event) => 
                    <ReferenceLine 
                        key={event.id}
                        x={event.createdAt}
                        stroke={event.label === "water start" ? "green" : event.label === "water end" ? "red" : "blue"}
                        strokeDasharray="3 3"
                        strokeWidth="3"
                    />
                )}                    
                {minimumTolerance && 
                    <ReferenceLine
                        y={minimumTolerance}
                        stroke="red"
                        label="min tolerance"
                        strokeDasharray="3 3"
                    />
                }
                {setPoint && 
                    <ReferenceLine y={setPoint} stroke="green" label="set point" strokeDasharray="3 3"/>
                }
                <Line dataKey={dataKey} dot={false}/>
            </LineChart>
        </ResponsiveContainer>
    )
};

export default SensorGraph;